import { FIELD_TYPES } from '../../../components/Form/EntityDetailsForm';

export const BANK_ACCOUNT_TEMPLATES = [
  {
    orderNumber: 1,
    translationId: 'page.user.bankAccounts.accountOne',
  },
  {
    orderNumber: 2,
    translationId: 'page.user.bankAccounts.accountTwo',
  },
  {
    orderNumber: 3,
    translationId: 'page.user.bankAccounts.accountThree',
  },
];

export const CURRENCY_OPTIONS = [
  {
    code: 'JPY',
    number: '392',
    digits: 0,
    currency: 'Yen',
    countries: [
      'Japan',
    ],
  },
  {
    code: 'AED',
    number: '784',
    digits: 2,
    currency: 'UAE Dirham',
    countries: [
      'United Arab Emirates (The)',
    ],
  },
  {
    code: 'ARS',
    number: '032',
    digits: 2,
    currency: 'Argentine Peso',
    countries: [
      'Argentina',
    ],
  },
  {
    code: 'AUD',
    number: '036',
    digits: 2,
    currency: 'Australian Dollar',
    countries: [
      'Australia',
      'Christmas Island',
      'Cocos (Keeling) Islands (The)',
      'Heard Island and Mcdonald Islands',
      'Kiribati',
      'Nauru',
      'Norfolk Island',
      'Tuvalu',
    ],
  },
  {
    code: 'BDT',
    number: '050',
    digits: 2,
    currency: 'Taka',
    countries: [
      'Bangladesh',
    ],
  },
  {
    code: 'BGN',
    number: '975',
    digits: 2,
    currency: 'Bulgarian Lev',
    countries: [
      'Bulgaria',
    ],
  },
  {
    code: 'BRL',
    number: '986',
    digits: 2,
    currency: 'Brazilian Real',
    countries: [
      'Brazil',
    ],
  },
  {
    code: 'CAD',
    number: '124',
    digits: 2,
    currency: 'Canadian Dollar',
    countries: [
      'Canada',
    ],
  },
  {
    code: 'CHF',
    number: '756',
    digits: 2,
    currency: 'Swiss Franc',
    countries: [
      'Liechtenstein',
      'Switzerland',
    ],
  },
  {
    code: 'CLP',
    number: '152',
    digits: 0,
    currency: 'Chilean Peso',
    countries: [
      'Chile',
    ],
  },
  {
    code: 'CNY',
    number: '156',
    digits: 2,
    currency: 'Yuan Renminbi',
    countries: [
      'China',
    ],
  },
  {
    code: 'COP',
    number: '170',
    digits: 2,
    currency: 'Colombian Peso',
    countries: [
      'Colombia',
    ],
  },
  {
    code: 'CRC',
    number: '188',
    digits: 2,
    currency: 'Costa Rican Colon',
    countries: [
      'Costa Rica',
    ],
  },
  {
    code: 'CZK',
    number: '203',
    digits: 2,
    currency: 'Czech Koruna',
    countries: [
      'Czechia',
    ],
  },
  {
    code: 'DKK',
    number: '208',
    digits: 2,
    currency: 'Danish Krone',
    countries: [
      'Denmark',
      'Faroe Islands (The)',
      'Greenland',
    ],
  },
  {
    code: 'EGP',
    number: '818',
    digits: 2,
    currency: 'Egyptian Pound',
    countries: [
      'Egypt',
    ],
  },
  {
    code: 'EUR',
    number: '978',
    digits: 2,
    currency: 'Euro',
    countries: [
      'Åland Islands',
      'Andorra',
      'Austria',
      'Belgium',
      'Croatia',
      'Cyprus',
      'Estonia',
      'European Union',
      'Finland',
      'France',
      'French Guiana',
      'French Southern Territories (The)',
      'Germany',
      'Greece',
      'Guadeloupe',
      'Holy See (The)',
      'Ireland',
      'Italy',
      'Latvia',
      'Lithuania',
      'Luxembourg',
      'Malta',
      'Martinique',
      'Mayotte',
      'Monaco',
      'Montenegro',
      'Netherlands (The)',
      'Portugal',
      'Réunion',
      'Saint Barthélemy',
      'Saint Martin (French Part)',
      'Saint Pierre and Miquelon',
      'San Marino',
      'Slovakia',
      'Slovenia',
      'Spain',
    ],
  },
  {
    code: 'FJD',
    number: '242',
    digits: 2,
    currency: 'Fiji Dollar',
    countries: [
      'Fiji',
    ],
  },
  {
    code: 'GBP',
    number: '826',
    digits: 2,
    currency: 'Pound Sterling',
    countries: [
      'Guernsey',
      'Isle of Man',
      'Jersey',
      'United Kingdom of Great Britain and Northern Ireland (The)',
    ],
  },
  {
    code: 'GEL',
    number: '981',
    digits: 2,
    currency: 'Lari',
    countries: [
      'Georgia',
    ],
  },
  {
    code: 'GHS',
    number: '936',
    digits: 2,
    currency: 'Ghana Cedi',
    countries: [
      'Ghana',
    ],
  },
  {
    code: 'HKD',
    number: '344',
    digits: 2,
    currency: 'Hong Kong Dollar',
    countries: [
      'Hong Kong',
    ],
  },
  {
    code: 'HUF',
    number: '348',
    digits: 2,
    currency: 'Forint',
    countries: [
      'Hungary',
    ],
  },
  {
    code: 'IDR',
    number: '360',
    digits: 2,
    currency: 'Rupiah',
    countries: [
      'Indonesia',
    ],
  },
  {
    code: 'ILS',
    number: '376',
    digits: 2,
    currency: 'New Israeli Sheqel',
    countries: [
      'Israel',
    ],
  },
  {
    code: 'INR',
    number: '356',
    digits: 2,
    currency: 'Indian Rupee',
    countries: [
      'Bhutan',
      'India',
    ],
  },
  {
    code: 'KES',
    number: '404',
    digits: 2,
    currency: 'Kenyan Shilling',
    countries: [
      'Kenya',
    ],
  },
  {
    code: 'KRW',
    number: '410',
    digits: 0,
    currency: 'Won',
    countries: [
      'Korea (The Republic Of)',
    ],
  },
  {
    code: 'LKR',
    number: '144',
    digits: 2,
    currency: 'Sri Lanka Rupee',
    countries: [
      'Sri Lanka',
    ],
  },
  {
    code: 'MAD',
    number: '504',
    digits: 2,
    currency: 'Moroccan Dirham',
    countries: [
      'Morocco',
      'Western Sahara',
    ],
  },
  {
    code: 'MXN',
    number: '484',
    digits: 2,
    currency: 'Mexican Peso',
    countries: [
      'Mexico',
    ],
  },
  {
    code: 'MYR',
    number: '458',
    digits: 2,
    currency: 'Malaysian Ringgit',
    countries: [
      'Malaysia',
    ],
  },
  {
    code: 'NGN',
    number: '566',
    digits: 2,
    currency: 'Naira',
    countries: [
      'Nigeria',
    ],
  },
  {
    code: 'NOK',
    number: '578',
    digits: 2,
    currency: 'Norwegian Krone',
    countries: [
      'Bouvet Island',
      'Norway',
      'Svalbard and Jan Mayen',
    ],
  },
  {
    code: 'NPR',
    number: '524',
    digits: 2,
    currency: 'Nepalese Rupee',
    countries: [
      'Nepal',
    ],
  },
  {
    code: 'NZD',
    number: '554',
    digits: 2,
    currency: 'New Zealand Dollar',
    countries: [
      'Cook Islands (The)',
      'New Zealand',
      'Niue',
      'Pitcairn',
      'Tokelau',
    ],
  },
  {
    code: 'PHP',
    number: '608',
    digits: 2,
    currency: 'Philippine Peso',
    countries: [
      'Philippines (The)',
    ],
  },
  {
    code: 'PKR',
    number: '586',
    digits: 2,
    currency: 'Pakistan Rupee',
    countries: [
      'Pakistan',
    ],
  },
  {
    code: 'PLN',
    number: '985',
    digits: 2,
    currency: 'Zloty',
    countries: [
      'Poland',
    ],
  },
  {
    code: 'RON',
    number: '946',
    digits: 2,
    currency: 'Romanian Leu',
    countries: [
      'Romania',
    ],
  },
  {
    code: 'SEK',
    number: '752',
    digits: 2,
    currency: 'Swedish Krona',
    countries: [
      'Sweden',
    ],
  },
  {
    code: 'SGD',
    number: '702',
    digits: 2,
    currency: 'Singapore Dollar',
    countries: [
      'Singapore',
    ],
  },
  {
    code: 'THB',
    number: '764',
    digits: 2,
    currency: 'Baht',
    countries: [
      'Thailand',
    ],
  },
  {
    code: 'TRY',
    number: '949',
    digits: 2,
    currency: 'Turkish Lira',
    countries: [
      'Türki̇ye',
    ],
  },
  {
    code: 'TZS',
    number: '834',
    digits: 2,
    currency: 'Tanzanian Shilling',
    countries: [
      'Tanzania, United Republic Of',
    ],
  },
  {
    code: 'UAH',
    number: '980',
    digits: 2,
    currency: 'Hryvnia',
    countries: [
      'Ukraine',
    ],
  },
  {
    code: 'UGX',
    number: '800',
    digits: 0,
    currency: 'Uganda Shilling',
    countries: [
      'Uganda',
    ],
  },
  {
    code: 'USD',
    number: '840',
    digits: 2,
    currency: 'US Dollar',
    countries: [
      'American Samoa',
      'Bonaire, Sint Eustatius and Saba',
      'British Indian Ocean Territory (The)',
      'Ecuador',
      'El Salvador',
      'Guam',
      'Haiti',
      'Marshall Islands (The)',
      'Micronesia (Federated States Of)',
      'Northern Mariana Islands (The)',
      'Palau',
      'Panama',
      'Puerto Rico',
      'Timor-Leste',
      'Turks and Caicos Islands (The)',
      'United States Minor Outlying Islands (The)',
      'United States of America (The)',
      'Virgin Islands (British)',
      'Virgin Islands (u.s.)',
    ],
  },
  {
    code: 'UYU',
    number: '858',
    digits: 2,
    currency: 'Peso Uruguayo',
    countries: [
      'Uruguay',
    ],
  },
  {
    code: 'VND',
    number: '704',
    digits: 0,
    currency: 'Dong',
    countries: [
      'Viet Nam',
    ],
  },
  {
    code: 'ZAR',
    number: '710',
    digits: 2,
    currency: 'Rand',
    countries: [
      'Lesotho',
      'Namibia',
      'South Africa',
    ],
  },
];

// The Bank Account data fields as in the API model
export const BANK_ACCOUNT_FIELDS = [
  {
    name: 'accountName',
    translationId: 'form.label.beneficiary.accountName',
    required: true,
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'accountNumber',
    translationId: 'form.label.beneficiary.accountNumber',
    obfuscated: true,
    required: true,
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'bankName',
    translationId: 'form.label.beneficiary.bankName',
    required: true,
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'currency',
    translationId: 'form.label.currency',
    required: true,
    type: FIELD_TYPES.dropdownList,
  },
  {
    name: 'branchName',
    translationId: 'form.label.beneficiary.branchName',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'bankBranchAddress',
    translationId: 'form.label.beneficiary.bankAddress',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'residenceCountry',
    translationId: 'form.label.beneficiary.currentCountryOfResidence',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'fullName',
    translationId: 'form.label.beneficiary.fullName',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'homeAddress',
    translationId: 'form.label.beneficiary.homeAddress',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'swiftCode',
    translationId: 'form.label.swiftCode',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'bsbCode',
    translationId: 'form.label.bsb',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'ibanCode',
    translationId: 'form.label.iban',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'intermediaryBankName',
    translationId: 'form.label.beneficiary.intermediaryBankName',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'intermediaryBankSwiftCode',
    translationId: 'form.label.beneficiary.intermediaryBankSwiftCode',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'intermediaryBankAccountNumber',
    translationId: 'form.label.beneficiary.intermediaryBankAccountNumber',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'reference',
    translationId: 'form.label.reference',
    type: FIELD_TYPES.inputText,
  },
  {
    name: 'verified',
    translationId: 'form.label.status',
    type: FIELD_TYPES.status,
    boolean: {
      label: {
        true: 'general.verified',
        false: 'general.unverified',
      },
    },
  },
];
